import DefaultDialogController from 'utils/notifications/default-dialog-controller';

@Inject('$state', '$timeout')
class AccountBlockedDialogController extends DefaultDialogController {
  constructor() {
    super();
  }

  onContactUsHandle() {
    this.close();
    this.$timeout(() => {
      this.$state.go('contact-view');
    }, 100);
  }
}

export default AccountBlockedDialogController;



// WEBPACK FOOTER //
// ./src/modules/auth/components/login-form/account-blocked-modal.js